namespace Gamification.Gamification {
    export interface ApiTipiOperazioniRow {
        IdApiTipoOperazione?: number;
        Nome?: string;
    }

    export namespace ApiTipiOperazioniRow {
        export const idProperty = 'IdApiTipoOperazione';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ApiTipiOperazioni';
        export const lookupKey = 'Gamification.ApiTipiOperazioni';

        export function getLookup(): Q.Lookup<ApiTipiOperazioniRow> {
            return Q.getLookup<ApiTipiOperazioniRow>('Gamification.ApiTipiOperazioni');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdApiTipoOperazione = "IdApiTipoOperazione",
            Nome = "Nome"
        }
    }
}
